//あいうえお
<template>






  <form id="app" action="" method="post" class="w-full">

    <p class="mb-5">{{contact.message}}</p>


    <div v-if="Object.keys(contact.errors).length" class="my-8 text-pink-800">
      <span class="font-medium">入力内容にエラーがあります。:</span>
      <ul class="ml-10">
        <li v-for="error in contact.errors" :key="error.key" class="list-disc">{{ error }}</li>
      </ul>
    </div>


    <div class="mb-10">
      <label class="block mb-1" for="inline-name">お名前：<span class="inline-block text-white bg-pink-700 text-base ml-5 px-4 py-1">必須</span></label>
      <input v-model="contact.name" v-bind:class="{'bg-pink-200 border-pink-800': contact.errors.name }" placeholder="お名前" class="bg-white appearance-none border border-gray-500 w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:border-blue-500" id="inline-name" type="text">
      <p v-if="contact.errors.name" class="text-pink-700">{{contact.errors.name}}</p>
    </div>

    <div class="mb-10">
      <label class="block mb-1" for="inline-email">Eメールアドレス：<span class="inline-block text-white bg-pink-700 text-base ml-5 px-4 py-1">必須</span></label>
      <input v-model="contact.email" v-bind:class="{'bg-pink-200 border-pink-800': contact.errors.email }" placeholder="Eメールアドレス" inputmode="email" class="bg-white appearance-none border border-gray-500 w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:border-blue-500" id="inline-email" type="text">
      <p v-if="contact.errors.email" class="text-pink-700">{{contact.errors.email}}</p>
    </div>


    <div class="mb-10">
      <label class="block mb-1" for="inline-age">年齢：</label>
      <input v-model="contact.age" v-bind:class="{'bg-pink-200 border-pink-800': contact.errors.age }" placeholder="30" class="bg-white appearance-none border border-gray-500 w-full md:w-20 py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:border-blue-500" id="inline-age" type="text">
      <p v-if="contact.errors.age" class="text-pink-700">{{contact.errors.age}}</p>
    </div>


    <div class="mb-10">
      <label class="block mb-1">性別：</label>
      <fieldset class="w-full flex flex-wrap">
        <legend>性別</legend>
        <div class="w-20 mr-5 inline-block" v-for="(gender, key) in contact.genders" :key="gender"><label class="inline-flex items-center"><input type="radio" v-model="contact.gender" :value="key">{{gender}}</label></div>
      </fieldset>
      <p v-if="contact.errors.gender" class="text-pink-700">{{contact.errors.gender}}</p>
    </div>


    <div class="mb-20">
      <label class="block mb-1" for="inline-content">ご感想、ご質問内容：<span class="inline-block text-white bg-pink-700 text-base ml-5 px-4 py-1">必須</span></label>
      <textarea v-model="contact.content" v-bind:class="{'bg-pink-200 border-pink-800': contact.errors.content }" placeholder="ご感想、ご質問内容" class="bg-white appearance-none border border-gray-500 w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:border-blue-500 h-10 sm:h-32" id="inline-content"></textarea>
      <p v-if="contact.errors.content" class="text-pink-700">{{contact.errors.content}}</p>
    </div>

    <div class="w-full text-center">
      <button type="button" @click="next" class="btn w-full sm:w-auto">入力内容の確認</button>
    </div>

  </form>







</template>

<script>
export default {
  props: [
   'contact'
  ],


  methods: {
    next(){
      this.$emit('step', 2);
    },
  }
}
</script>

<style>

</style>
